import { Languages } from "lucide-react";
import { useLang } from "../lang/LanguageContext";

export default function LanguageToggle({ className = "", testId = "language-toggle" }) {
    const { lang, setLang } = useLang();
    return (
        <button
            type="button"
            onClick={() => setLang(lang === "en" ? "es" : "en")}
            data-testid={testId}
            aria-label={lang === "en" ? "Switch site to Spanish" : "Cambiar el sitio a inglés"}
            className={`inline-flex items-center justify-center gap-1.5 ${className}`}
        >
            <Languages size={18} />
            {lang === "en" ? "Español" : "English"}
        </button>
    );
}
